// extracted by mini-css-extract-plugin
export var accentColor = "#ff723d";
export var categoryBorderColor = "#15ba8f";
export var disableRipple = "false";
export var mainColor = "#e60000";
export var mainContrast = "#fff";
export var panelBorderColor = "#ccc";
export var secondaryColor = "#333";
export var secondaryContrast = "#fff";